import type { ReactNode } from 'react';
import { Box, Typography } from '@mui/material';

type ListCardFieldProps = {
  label: string;
  children: ReactNode;
};

/** Etiqueta + valor dentro de una tarjeta de listado. */
export function ListCardField({ label, children }: ListCardFieldProps) {
  return (
    <Box sx={{ minWidth: 0 }}>
      <Typography
        variant="caption"
        color="text.secondary"
        sx={{ fontWeight: 700, letterSpacing: 0.03, textTransform: 'uppercase', fontSize: '0.65rem', display: 'block' }}
      >
        {label}
      </Typography>
      <Box sx={{ mt: 0.35 }}>{children}</Box>
    </Box>
  );
}
